/**
 * order-form
 */

import Component from "../../js/lib/component";

/* global $ */

const classList = {
  root: ".js-order-form",
  radio: ".js-order-form-radio",
  field: ".js-order-form-field"
};

export default class OrderForm extends Component {
  init() {
    this.$.radio
      .filter(":checked")
      .prop("checked", true)
      .removeAttr("checked");
    this.updateFieldsState();
  }
  events() {
    this.$.radio.on("change", e => {
      this.updateFieldsState();
    });
  }
  updateFieldsState() {
    this.$.field.hide();
    this.$.radio.each((i, radio) => {
      if (radio.checked) {
        this.$.field
          .filter((i, field) => field.dataset.name === radio.value)
          .show();
      }
    });
  }
}

Component.mount(OrderForm, {
  name: "OrderForm",
  classList,
  state: {}
});
